import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Faq.module.scss'

import { Container, Accordion } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class Faq extends React.Component {
  
  render() {

    const { data } = this.props

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.rtext || ``}
          />
          <div className={styles.content}>
            <Accordion className={styles.accordion}>
              {data?.part1.map( ( elm, k ) => (
                <Accordion.Item eventKey={k}>
                  <Accordion.Header>{elm.title}</Accordion.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{__html: elm?.text}} />
                </Accordion.Item>
              ) )}
            </Accordion>
            <Accordion className={`${styles.accordion} ${styles.accordion_mhide}`}>
              {data?.part2.map( ( elm, k ) => (
                <Accordion.Item eventKey={k}>
                  <Accordion.Header>{elm.title}</Accordion.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{__html: elm?.text}} />
                </Accordion.Item>
              ) )}
            </Accordion>
          </div>
          {data?.part3.length > 0 &&
            <Accordion className={`${styles.accordion_mhide}`}>
              {data?.part3.map( ( elm, k ) => (
                <Accordion.Item eventKey={k}>
                  <Accordion.Header>{elm.title}</Accordion.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{__html: elm?.text}} />
                </Accordion.Item>
              ) )}
            </Accordion>
          }
        </Container>
      </section>
    )
  }
}

Faq.propTypes = {
  data: PropTypes.object
}

Faq.defaultProps = {
  data: {}
}

export default Faq